import styled from 'styled-components';

export const MainFooter = styled.footer`
    max-width: 1120px;
    margin: 0 auto;
`;
